import { Dispatch, useEffect, useMemo, useState } from 'react';

import { Filter } from 'components';
import { FilterField } from 'components/common/Filter';
import { useApiAccess } from 'contexts/AccessProvider';
import { FilterType, useFilterQuery } from 'gql';
import { useSearchParams } from 'react-router-dom';

function useFilter(filterType: FilterType, setPageNumber: Dispatch<number>) {
  const { sessionKey } = useApiAccess();
  const [searchParams, setSearchParams] = useSearchParams();

  const { data, loading } = useFilterQuery({
    variables: { sessionKey, filterType },
  });

  const [filterValue, setFilterValue] = useState<Array<string>>([]);
  const [selectedField, setSelectedField] = useState({ column: '', value: '' });

  useEffect(() => {
    const params = Object.fromEntries(searchParams.entries());
    const nonFilterParams = ['page', 'size', 'section'];
    const filterColumn = Object.keys(params).find((key) => !nonFilterParams.includes(key));

    if (filterColumn) {
      setSelectedField({ column: filterColumn, value: params[filterColumn] });
    } else {
      setSelectedField({ column: '', value: '' });
    }
  }, [searchParams]);

  let filterKeys: Array<string> = useMemo(() => [], []);
  if (data) {
    filterKeys = data.filter.filterKey as Array<string>;
  }

  const handleApply = (obj: { column: string; value: string }) => {
    setSelectedField(obj);
    setSearchParams({ ...searchParams, [obj.column]: obj.value });
    setPageNumber(1);
  };

  const FilterController = useMemo(() => {
    return (
      <Filter
        filterField={filterKeys as FilterField[]}
        filterValue={filterValue}
        handleApply={handleApply}
        setFilterValue={setFilterValue}
        data={data}
        filterType={filterType}
      />
    );
  }, [filterValue, filterKeys, data, filterType]);

  return { loading, FilterController, selectedField };
}

export default useFilter;
